import React, { Component } from 'react';
import './HomePageIndex.css';

// Add future home page destinations here, then give the matching section this id.
export const HOME_PAGE_SECTIONS = [
  { id: 'home-showcase', label: 'Explore', theme: 'dark' },
  { id: 'home-benefits', label: 'Benefits', theme: 'dark' },
  { id: 'home-faq', label: 'FAQs', theme: 'light' },
  { id: 'home-pricing', label: 'Pricing', theme: 'light' }
];

class HomePageIndex extends Component {
  state = {
    activeSection: HOME_PAGE_SECTIONS[0].id,
    isVisible: false,
    isCompactMenuOpen: false,
    compactTop: null
  };

  componentDidMount() {
    this.updateActiveSection();
    this.updateCompactTop();
    window.addEventListener('scroll', this.updateActiveSection, { passive: true });
    window.addEventListener('resize', this.updateActiveSection);
    document.addEventListener('click', this.handleOutsideClick, true);

    const navbar = document.querySelector('.navbar.site-navbar');
    if (navbar && typeof ResizeObserver !== 'undefined') {
      this.navbarResizeObserver = new ResizeObserver(this.updateCompactTop);
      this.navbarResizeObserver.observe(navbar);
    }
  }

  componentDidUpdate() {
    this.updateDesktopPosition();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateActiveSection);
    window.removeEventListener('resize', this.updateActiveSection);
    document.removeEventListener('click', this.handleOutsideClick, true);
    this.navbarResizeObserver?.disconnect();
  }

  updateCompactTop = () => {
    const navbar = document.querySelector('.navbar.site-navbar');
    const menuIsOpenOrClosing = navbar?.classList.contains('is-expanded') ||
      navbar?.querySelector('.navbar-collapse.collapsing');
    const followsExpandedMenu = window.innerWidth <= 991.98 && menuIsOpenOrClosing;
    const compactTop = followsExpandedMenu
      ? `${Math.round(navbar.getBoundingClientRect().bottom + 12)}px`
      : null;

    if (compactTop !== this.state.compactTop) {
      this.setState({ compactTop });
    }
  };

  updateActiveSection = () => {
    this.updateCompactTop();
    this.updateDesktopPosition();
    const activeSection = HOME_PAGE_SECTIONS.reduce((activeId, section) => {
      const element = document.getElementById(section.id);
      return element && element.getBoundingClientRect().top <= window.innerHeight * 0.4
        ? section.id
        : activeId;
    }, HOME_PAGE_SECTIONS[0].id);

    const benefitsSection = document.getElementById('home-benefits');
    const isVisible = window.scrollY > 80 && benefitsSection &&
      benefitsSection.getBoundingClientRect().top < window.innerHeight * 0.85;

    if (activeSection !== this.state.activeSection || isVisible !== this.state.isVisible) {
      this.setState({ activeSection, isVisible });
    }
  };

  updateDesktopPosition = () => {
    const index = this.desktopIndex;
    const footerBoundary = document.getElementById('home-footer-boundary');

    if (!index || !footerBoundary || window.innerWidth < 1920) {
      if (index) {
        index.style.top = '';
        index.style.transform = '';
      }
      return;
    }

    const footerTop = footerBoundary.getBoundingClientRect().top;
    const bottomLimit = footerTop - 32;
    const centeredBottom = window.innerHeight / 2 + index.offsetHeight / 2;

    if (centeredBottom > bottomLimit) {
      index.style.top = `${Math.round(bottomLimit - index.offsetHeight)}px`;
      index.style.transform = 'none';
    } else {
      index.style.top = '';
      index.style.transform = '';
    }
  };

  closeCompactMenu = () => this.setState({ isCompactMenuOpen: false });

  handleOutsideClick = (event) => {
    if (this.state.isCompactMenuOpen && this.compactIndex && !this.compactIndex.contains(event.target)) {
      this.closeCompactMenu();
    }
  };

  renderLinks = (className) => (
    <ol className={className}>
      {HOME_PAGE_SECTIONS.map((section, index) => (
        <li key={section.id}>
          <a
            href={`#${section.id}`}
            aria-current={this.state.activeSection === section.id ? 'location' : undefined}
            onClick={this.closeCompactMenu}
          >
            <span className="home-page-index-number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
            <span>{section.label}</span>
          </a>
        </li>
      ))}
    </ol>
  );

  render() {
    if (!this.state.isVisible) return null;

    const activeSection = HOME_PAGE_SECTIONS.find(section => section.id === this.state.activeSection);
    const themeClass = `is-on-${activeSection.theme}`;

    return (
      <>
        <nav
          ref={element => { this.desktopIndex = element; }}
          className={`home-page-index-desktop ${themeClass}`}
          aria-label="Home page sections"
        >
          <p>On this page</p>
          {this.renderLinks('home-page-index-list')}
        </nav>

        <div
          ref={element => { this.compactIndex = element; }}
          className={`home-page-index-compact ${themeClass}`}
          style={this.state.compactTop ? { top: this.state.compactTop } : undefined}
        >
          <button
            type="button"
            className="home-page-index-compact-toggle"
            aria-label={this.state.isCompactMenuOpen ? 'Close section index' : 'Open section index'}
            aria-expanded={this.state.isCompactMenuOpen}
            aria-controls="home-page-index-compact-panel"
            onClick={() => this.setState(state => ({ isCompactMenuOpen: !state.isCompactMenuOpen }))}
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M5 6h14M5 12h14M5 18h14" />
              <circle cx="3" cy="6" r=".6" />
              <circle cx="3" cy="12" r=".6" />
              <circle cx="3" cy="18" r=".6" />
            </svg>
          </button>
          <div
            id="home-page-index-compact-panel"
            className="home-page-index-compact-panel"
            hidden={!this.state.isCompactMenuOpen}
          >
            <nav aria-label="Home page sections">
              <p>On this page</p>
              {this.renderLinks('home-page-index-list')}
            </nav>
          </div>
        </div>
      </>
    );
  }
}

export default HomePageIndex;
